<template>
  <div>
    <div class="mt-2">
      <SearchTabs
        v-model="replysStatus"
        :options="searchTabOpts"
        @change="editReload({ isReset: true })"
      />
    </div>

    <PageMain
      ref="main"
      :disabled="disabled"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :isVc="isVc"
      @reload="reload"
      @openReplyEdit="openReplyEdit"
      @submit="submitApi"
      @checkbox-change="(data) => (checkedRows = data)"
    >
      <template slot="header">
        <div class="d-flex" style="padding-right: 12px;">
          <PageHeader
            ref="header"
            :isVc="isVc"
            @query="getData"
            @reset="resetPage"
          />
          <el-badge
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
            v-if="!disabled"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="submit()"
              :disabled="!checkedRowCount"
            >
              {{ $l('menu_text_submit') || '提交运营确认' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>

          <el-badge
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
            v-if="!disabled"
          >
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-primary"
              @click="autoReply()"
              :disabled="!checkedRowCount"
            >
              {{ $l('btn_autoReply') || '批量确认补货' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>

          <el-badge
            :value="checkedRowCount"
            :hidden="!checkedRowCount"
            class="clearable-button"
            :class="{ clearable: !!checkedRowCount }"
            v-if="!disabled"
          >
            <b-button
              v-allow="'OS'"
              size="sm"
              class="ml-2"
              variant="outline-danger"
              @click="outStockBatch()"
              :disabled="!checkedRowCount"
            >
              {{ $l('btn_autoOutStock') || '批量缺货确认' }}
              <i class="el-icon-circle-close" @click.stop="clearCheckboxRow" />
            </b-button>
          </el-badge>
        </div>
      </template>
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>
    <SkuReply
      :disabled="disabled"
      :visible.sync="skuReplyOptions.visible"
      :amzReplenishmentDetailCode="skuReplyOptions.amzReplenishmentDetailCode"
      @reload="editReload"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import SkuReply from '../sku-reply'
import SearchTabs from './search-tabs'
import BaseTable from '@/mixins/base-table'
import EditLoading from '@/mixins/edit-loading'
import { add } from '@/libs/util.number.js'
export default {
  mixins: [BaseTable, EditLoading],
  components: { PageMain, PageHeader, SkuReply, SearchTabs },
  props: {
    disabled: { type: Boolean, default: false },
    amzReplenishmentCode: { type: String, default: '' },
    isVc: { type: String, default: '' },
  },
  data() {
    return {
      usePage: true,
      skuReplyOptions: { visible: false, amzReplenishmentDetailCode: '' },
      replysStatus: 'R',
      notreplys: 0,
      replys: 0,
      unsubmitted: 0,
      submitted: 0,
      rejected: 0,
      confirmed: 0,
      checkedRows: [],
    }
  },
  computed: {
    searchTabOpts() {
      return [
        {
          label: this.$l('search_tabs_label_totalCount') || '全部',
          value: '',
          badge: add(this.notreplys, this.replys),
        },
        {
          label: this.$l('search_tabs_label_notreplys') || '未返答',
          value: 'R',
          badge: this.notreplys,
        },
        {
          label: this.$l('search_tabs_label_replys') || '已返答',
          value: 'A',
          badge: this.replys,
        },
        {
          label: this.$l('search_tabs_label_unsubmitted') || '未提交',
          value: 'N',
          badge: this.unsubmitted,
        },
        {
          label: this.$l('search_tabs_label_submitted') || '已提交',
          value: 'S',
          badge: this.submitted,
        },
        {
          label: this.$l('search_tabs_label_rejected') || '驳回',
          value: 'B',
          badge: this.rejected,
        },
        {
          label: this.$l('search_tabs_label_confirmed') || '已确认',
          value: 'Y',
          badge: this.confirmed,
        },
      ]
    },
    checkedRowCount() {
      return this.checkedRows?.length || 0
    },
  },
  methods: {
    editReload({ isReset = false } = {}) {
      this.reload({ isReset })
      this.clearCheckboxRow()
    },
    async getData(form) {
      if (!this.amzReplenishmentCode) return

      let params = {
        ...form,
        listReplysStatus: [this.replysStatus].filter(Boolean),
      }
      if ('R' === this.replysStatus) {
        params = { ...params, listApprovalStatus: ['Y'], listReplysStatus: [] }
      }
      if ('A' === this.replysStatus) {
        params = { ...params, listApprovalStatus: ['C'], listReplysStatus: [] }
      }
      this.getTableData(params)

      // 统计数据查询
      this.getCount({ ...form, listApprovalStatus: ['Y'] }).then((count) => {
        this.notreplys = count
      })
      this.getCount({ ...form, listApprovalStatus: ['C'] }).then((count) => {
        this.replys = count
      })
      this.getCount({ ...form, listReplysStatus: ['N'] }).then((count) => {
        this.unsubmitted = count
      })
      this.getCount({ ...form, listReplysStatus: ['S'] }).then((count) => {
        this.submitted = count
      })
      this.getCount({ ...form, listReplysStatus: ['B'] }).then((count) => {
        this.rejected = count
      })
      this.getCount({ ...form, listReplysStatus: ['Y'] }).then((count) => {
        this.confirmed = count
      })
    },
    getTableData(params = {}) {
      this.loading = true
      this.$api
        .ecomAmzReplenishmentDetailListApi({
          ...params,
          ...this.page,
          amzReplenishmentCode: this.amzReplenishmentCode,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
          this.$emit('reload')
        })
        .catch(() => {
          this.loading = false
        })
    },
    async getCount(params = {}) {
      const res = await this.$api
        .ecomAmzReplenishmentDetailCountApi({
          ...params,
          amzReplenishmentCode: this.amzReplenishmentCode,
        })
        .catch(() => null)
      if (!res) return 0
      return res.body || 0
    },
    openReplyEdit({ amzReplenishmentDetailCode }) {
      this.skuReplyOptions = { visible: true, amzReplenishmentDetailCode }
    },
    async submitApi(listCode) {
      const confirm = await this.$confirm(
        this.$l('confirmTips_submit') || '是否确认提交给运营确认？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      this.loadingOpen()
      const res = await this.$api
        .ecomAmzReplenishmentDetailReplyOutSubmitApi({ listCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_submission_failed'))
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_Submitted_successfully'),
        type: 'success',
      })
      this.editReload()
    },
    clearCheckboxRow() {
      this.checkedRows = []
      this.$refs.main.clearCheckboxRow()
    },
    submit() {
      if (!this.checkedRowCount) {
        this.$message({
          message:
            this.$l('tips_submitEmpty') || '请选择需要提交运营确认的补货明细',
          type: 'warning',
        })
        return
      }

      const listCode = this.checkedRows.map(
        (row) => row.amzReplenishmentDetailCode
      )
      this.submitApi(listCode)
    },
    async autoReply() {
      if (!this.checkedRowCount) {
        this.$message({
          message:
            this.$l('tips_autoReplyEmpty') || '请选择需要批量确认补货的补货明细',
          type: 'warning',
        })
        return
      }

      const confirm = await this.$confirm(
        this.$l('tips_confirm_autoReply') ||
          '是否确认将选中的补货明细进行批量确认补货？批量确认补货将覆盖已填写的数据！',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const listCode = this.checkedRows.map(
        (row) => row.amzReplenishmentDetailCode
      )

      this.loadingOpen()
      const res = await this.$api
        .ecomAmzReplenishmentDetailReplyAutoReplenishmentApi({ listCode })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('tips_autoReply_failed'))
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('tips_autoReply_successfully'),
        type: 'success',
      })
      this.editReload()
    },
    async outStockBatch() {
      if (!this.checkedRowCount) {
        this.$message({
          message:
            this.$l('tips_autoOutStockEmpty') ||
            '请选择需要批量缺货确认的补货明细',
          type: 'warning',
        })
        return
      }

      const confirm = await this.$confirm(
        this.$l('tips_confirmAutoOutStock') ||
          '是否确认将选中的补货明细进行批量缺货确认？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return

      const listCode = this.checkedRows.map(
        (row) => row.amzReplenishmentDetailCode
      )

      this.loadingOpen()
      const res = await this.$api
        .ecomAmzReplenishmentDetailReplyOutStockBatchApi({ listCode })
        .catch(() => null)
      this.loadingClose()

      if (!res) return
      if (res.status !== 200) {
        if (res.msg) this.$message.error(res.msg)
        return
      }
      this.$message({
        showClose: true,
        message:
          this.$l('tips_autoOutStockSuccessfully') || '批量缺货确认成功',
        type: 'success',
      })
      this.editReload()
    },
  },
}
</script>
<style lang="scss" scoped>
.search-form {
  flex: 1;
  max-width: 600px;
  min-width: 300px;
}

.clearable-button {
  .el-icon-circle-close {
    display: none;
  }
}
.clearable-button.clearable:hover {
  .el-icon-circle-close {
    display: inline-block;
    z-index: 999;
  }
  .el-icon-circle-close:hover {
    transform: scale(1.2);
  }
}
</style>
